
import { Component, Vue } from 'vue-property-decorator'
import {
  currenciesContainer,
  ICurrenciesMachine,
} from '~/apps/currencies/currencies/inversify.config'
import { CurrenciesMachineInterpreter } from '../../../../apps/currencies/currencies/machine'

@Component
export default class CurrencySwitchMenu extends Vue {
  state: CurrenciesMachineInterpreter['state'] | null = null

  get currencies():
  | CurrenciesMachineInterpreter['state']['context']['currencies']
  | undefined {
    return this.state?.context?.currencies
  }

  get currentCurrency() {
    return this.currencies && this.currencies[this.$i18n.current.currency]
  }

  mounted() {
    this.startMachines()
  }

  private startMachines() {
    this.state = currenciesContainer
      .get<CurrenciesMachineInterpreter>(ICurrenciesMachine)
      .onTransition((state) => (this.state = state)).state
  }
}
